import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isFunction } from 'lodash';
import React from 'react';
import { findFirst } from "../arrays";

/** ХОК, который позволяет привязать аналитику к хэндлерам (клик, блур и т.д.) */
export function withControlAnalytics(eventType, handler) {
  return function (WrappedComponent) {
    var Component = function Component(props) {
      var value = props[eventType];
      var _props = findFirst([isFunction(handler) && _objectSpread(_objectSpread({}, props), {}, _defineProperty({}, eventType, function () {
        if (isFunction(value)) value.apply(void 0, arguments);
        handler.apply(void 0, arguments);
      }))]) || props;
      return /*#__PURE__*/React.createElement(WrappedComponent, _props);
    };
    return Component;
  };
}